import Vue from "vue";
import VueResource from "vue-resource";
import Router from "vue-router";
import Home from "./views/Home.vue";
import About from "./views/About.vue";
import Lang from "./views/Lang.vue";
import Ecommerce from "./views/Ecommerce.vue";
import CreditCard from "./views/CreditCard.vue";
import Transfer from "./views/Transfer/main.vue";
import NvbbDrink from "./views/NvbbDrink.vue";
import GetCurrentLocation from "@/components/ecommerce/GetCurrentLocation.vue";
import FindNearShop from "./views/Volvoline/FindNearShop.vue";
import CreditGBPrime from "./views/Payment/CreditGBPrime.vue";

// import { store } from "@/store/store";

import NotFoundView from "./components/error/404.vue";

Vue.use(Router);
Vue.use(VueResource);
// const allLang = ["en", "th", "la"];

const routes = [
  {
    path: "/",
    beforeEnter(to, from, next) {
      // if (!to.query.lang) {
      //   router.replace({
      //     path: to.fullPath,
      //     query: { lang: "en" }
      //   });
      // }
      // let language = to.query.lang ? to.query.lang : "en";
      // if (!allLang.includes(language)) {
      //   router.replace({
      //     path: to.fullPath,
      //     query: { lang: "en" }
      //   });
      //   return next();
      // }
      // store.dispatch("setLang", language);

      return next();
    },
    component: Lang,
    children: [
      {
        path: "",
        name: "home",
        component: Home,
      },
      {
        path: "about",
        name: "about",
        component: About,
      },
      {
        path: "ecommerce/:id",
        name: "ecommerce",
        component: Ecommerce,
      },
      {
        path: "creditcard/:id",
        name: "creditcard",
        component: CreditCard,
      },
      {
        path: "transfer/:id",
        name: "transfer",
        component: Transfer,
      },
      {
        path: "creditgbprime/:id",
        name: "creditgbprime",
        component: CreditGBPrime,
      },

      {
        path: "getcurrentlocation/:id",
        name: "getcurrentlocation",
        component: GetCurrentLocation,
      },
      {
        path: "nvbbdrink/:id",
        name: "NvbbDrink",
        component: NvbbDrink,
      },
      {
        path: "volvoline/nearshop",
        name: "volvoline",
        component: FindNearShop,
      },
      {
        // not found handler
        path: "*",
        component: NotFoundView,
      },
    ],
  },
];

const router = new Router({
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched
  //   .slice()
  //   .reverse()
  //   .find(r => r.meta && r.meta.metaTags);

  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map((el) =>
    el.parentNode.removeChild(el)
  );
  if (!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      tag.setAttribute("data-router-controlled", "");

      return tag;
    })
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

export default router;
